export default {
	USER_COLOR: 'white',
	VISIT_COLOR: '#e5ebf9',
	GUEST_COLOR: 'rgb(238, 238, 236)'
}
